import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/indexRedux';
import Loading from '../components/ui/Loading';

const CompanyProtectedRoute: React.FC = () => {
  const { selectedUserCompany, loading } = useSelector((state: RootState) => state.selectedCompany);

  // If company data is still loading, show a spinner or loader component
  if (loading) {
    return <Loading />;
  }

  // Once loading is done, if no company is selected, redirect to the select company page
  if (!selectedUserCompany) {
    return <Navigate to='/' replace />;
  }

  // If loading is done and company is selected, proceed with protected routes
  return <Outlet />;
};

export default CompanyProtectedRoute;
